import React from 'react';

const CaseSuccessIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      style={{
        height: props.height ? `${props.height}px` : '',
        width: props.height ? `${props.height}px` : ''
      }}
      viewBox="0 0 26 26"
    >
      <path fill="#00B080" fillRule="evenodd" d="M17.8 6.053h4.8c1.332 0 2.4 1.124 2.4 2.526v13.895C25 23.876 23.932 25 22.6 25H3.4C2.068 25 1 23.876 1 22.474l.012-13.895c0-1.402 1.056-2.526 2.388-2.526h4.8V3.526C8.2 2.124 9.268 1 10.6 1h4.8c1.332 0 2.4 1.124 2.4 2.526v2.527Zm-7.2-.25h4.8v-2.4h-4.8v2.4Z" clipRule="evenodd"/>
      <path fill="#004840" d="M17.8 6.053h-.5v.5h.5v-.5ZM1 22.473H.5 1ZM1.012 8.58h.5-.5ZM8.2 6.053v.5h.5v-.5h-.5Zm7.2-.25v.5h.5v-.5h-.5Zm-4.8 0h-.5v.5h.5v-.5Zm4.8-2.4h.5v-.5h-.5v.5Zm-4.8 0v-.5h-.5v.5h.5Zm12 2.15h-4.8v1h4.8v-1Zm2.9 3.026c0-1.654-1.268-3.026-2.9-3.026v1c1.032 0 1.9.876 1.9 2.026h1Zm0 13.895V8.579h-1v13.895h1ZM22.6 25.5c1.632 0 2.9-1.372 2.9-3.026h-1c0 1.15-.868 2.026-1.9 2.026v1Zm-19.2 0h19.2v-1H3.4v1ZM.5 22.474c0 1.654 1.268 3.026 2.9 3.026v-1c-1.032 0-1.9-.876-1.9-2.026h-1ZM.512 8.579.5 22.473l1 .001.012-13.895h-1ZM3.4 5.553C1.765 5.553.512 6.929.512 8.579h1c0-1.154.86-2.026 1.888-2.026v-1Zm4.8 0H3.4v1h4.8v-1Zm-.5-2.027v2.527h1V3.526h-1ZM10.6.5C8.968.5 7.7 1.873 7.7 3.526h1c0-1.15.868-2.026 1.9-2.026v-1Zm4.8 0h-4.8v1h4.8v-1Zm2.9 3.026C18.3 1.873 17.032.5 15.4.5v1c1.032 0 1.9.876 1.9 2.026h1Zm0 2.527V3.526h-1v2.527h1Zm-2.9-.75h-4.8v1h4.8v-1Zm-.5-1.9v2.4h1v-2.4h-1Zm-4.3.5h4.8v-1h-4.8v1Zm.5 1.9v-2.4h-1v2.4h1Z"/>
      <path fill="#004840" fillRule="evenodd" d="M7 15.5a6 6 0 1 1 12 0 6 6 0 1 1-12 0Zm2.646-.238 1.896 1.796L16.36 12.5l.641.607-5.458 5.17L9 15.87l.646-.607Z" clipRule="evenodd"/>
    </svg>
  );
};

CaseSuccessIcon.defaultProps = { height: 16 };
export default CaseSuccessIcon;
